import React, { useState, useEffect, useRef } from "react";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  treatmentPlanService,
  QRCodeResponse,
} from "../../../services/treatmentPlanService";
import {
  ContentContainer,
  ModalTitle,
  ModalDescription,
  QRCodeContainer,
  QRCodeImage,
  LoadingContainer,
  ErrorText,
} from "./QRCodeSignModal.styled";

interface QRCodeSignModalContentProps {
  treatmentPlanId: string | number;
}

const QRCodeSignModalContent: React.FC<QRCodeSignModalContentProps> = ({
  treatmentPlanId,
}) => {
  const { t } = useTranslation();
  const [qrData, setQrData] = useState<QRCodeResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const fetchedRef = useRef(false);

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    const generateQR = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await treatmentPlanService.generateQR(treatmentPlanId);
        setQrData(data);
      } catch (err) {
        console.error("Error generating QR code:", err);
        setError(t("qrCodeSign.error"));
      } finally {
        setLoading(false);
      }
    };

    generateQR();
  }, [treatmentPlanId, t]);

  return (
    <ContentContainer>
      <ModalTitle>{t("qrCodeSign.title")}</ModalTitle>
      <ModalDescription>{t("qrCodeSign.description")}</ModalDescription>

      <QRCodeContainer>
        {loading ? (
          <LoadingContainer>
            <CircularProgress />
          </LoadingContainer>
        ) : error ? (
          <ErrorText>{error}</ErrorText>
        ) : qrData ? (
          <QRCodeImage src={qrData.qrCodeImage} alt={t("qrCodeSign.altText")} />
        ) : null}
      </QRCodeContainer>
    </ContentContainer>
  );
};

export default QRCodeSignModalContent;
